import { render, staticRenderFns } from "./chaternewxbk.vue?vue&type=template&id=76b52e70&scoped=true"
import script from "./chaternewxbk.vue?vue&type=script&lang=js"
export * from "./chaternewxbk.vue?vue&type=script&lang=js"
import style0 from "./chaternewxbk.vue?vue&type=style&index=0&id=76b52e70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b52e70",
  null
  
)

export default component.exports